import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from '../Popover';
import { StyledIndicator, StyledLabel, StyledRoot, StyledProgressBarContainer } from './styled';
import { tokens } from './tokens';
import { Variant, LabelPosition } from './types';
export const ProgressBar = ({ variant = Variant.loading, value, height = tokens.ProgressBar.height, width = tokens.ProgressBar.width, labelPosition = false, customLabel, className, style, color, ...rest })=>{
    const isFloatingLabel = labelPosition === LabelPosition.top_floating || labelPosition === LabelPosition.bottom_floating;
    const isStaticLabel = labelPosition === LabelPosition.right || labelPosition === LabelPosition.bottom;
    const progressValue = value || 0;
    const progressLabel = customLabel || `${progressValue}%`;
    return /*#__PURE__*/ _jsxs(StyledProgressBarContainer, {
        $width: width,
        $labelPosition: isStaticLabel ? labelPosition : undefined,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(StyledRoot, {
                height: height,
                width: width,
                value: value,
                ...rest,
                children: isFloatingLabel ? /*#__PURE__*/ _jsx(Popover, {
                    visible: true,
                    align: "end",
                    onOpenAutoFocus: (e)=>e.preventDefault(),
                    overlay: /*#__PURE__*/ _jsx(StyledLabel, {
                        children: progressLabel
                    }),
                    overlayStyle: {
                        minWidth: '0',
                        transform: 'translateX(50%)'
                    },
                    placement: labelPosition === LabelPosition.bottom_floating ? 'bottom' : 'top',
                    children: /*#__PURE__*/ _jsx(StyledIndicator, {
                        "data-variant": variant,
                        $variant: variant,
                        $value: progressValue,
                        $color: color
                    })
                }) : /*#__PURE__*/ _jsx(StyledIndicator, {
                    "data-variant": variant,
                    $variant: variant,
                    $value: progressValue,
                    $color: color
                })
            }),
            isStaticLabel && /*#__PURE__*/ _jsx(StyledLabel, {
                children: progressLabel
            })
        ]
    });
};
export * from './SegmentedProgressBar';
